module.exports = __webpack_public_path__ + "static/gallery6-0d888e2a9fbabac305c4ab2f20d7444a.jpg";